/**
 * Product Thumbnail Hover for Desktop
 * Changes main product image on hover instead of click on desktop devices
 */

(function() {
  'use strict';

  // Media query for desktop (above 960px to match theme's breakpoint)
  const desktopMediaQuery = window.matchMedia('(min-width: 960px)');

  let hoverListeners = [];

  function initThumbnailHover() {
    // Only run on desktop
    if (!desktopMediaQuery.matches) {
      return;
    }

    const thumbnailButtons = document.querySelectorAll('[data-product-thumbnail]');
    const desktopMedia = document.querySelector('.product__media-container.above-mobile');
    const viewInYourSpace = document.querySelector('[data-in-your-space]');

    if (!thumbnailButtons.length || !desktopMedia) {
      return;
    }

    // Add hover event to each thumbnail
    thumbnailButtons.forEach(button => {
      const hoverHandler = (e) => {
        const thumbnailId = button.dataset.thumbnailId;

        if (thumbnailId) {
          // Remove active class from all thumbnails
          thumbnailButtons.forEach(thumb => thumb.classList.remove('active'));

          // Add active class to hovered thumbnail
          button.classList.add('active');

          // Switch the main image
          switchImage(desktopMedia, thumbnailId, viewInYourSpace);
        }
      };

      // Add mouseenter event for hover
      button.addEventListener('mouseenter', hoverHandler);

      // Store listener reference for cleanup
      hoverListeners.push({ element: button, handler: hoverHandler });
    });
  }

  // Helper function to switch images (adapted from theme code)
  function switchImage(container, id, viewInYourSpace) {
    const mediaItems = container.querySelectorAll('[data-product-media-wrapper]');

    mediaItems.forEach(item => {
      const mediaId = item.dataset.mediaItemId;

      if (mediaId === id) {
        item.classList.remove('hidden');

        // Handle 3D model visibility
        if (viewInYourSpace) {
          const isModel = item.querySelector('model-viewer');
          if (isModel) {
            viewInYourSpace.setAttribute('data-shopify-model3d-id', id);
          }
        }
      } else {
        item.classList.add('hidden');
      }
    });
  }

  // Cleanup function
  function destroyThumbnailHover() {
    hoverListeners.forEach(({ element, handler }) => {
      element.removeEventListener('mouseenter', handler);
    });
    hoverListeners = [];
  }

  // Handle breakpoint changes
  function handleBreakpointChange() {
    destroyThumbnailHover();
    initThumbnailHover();
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initThumbnailHover);
  } else {
    initThumbnailHover();
  }

  // Re-initialize on window resize (debounced)
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(handleBreakpointChange, 250);
  });

  // Re-initialize when product variant changes (for dynamic content)
  document.addEventListener('product:variant-change', () => {
    setTimeout(initThumbnailHover, 100);
  });

  // Re-initialize after theme AJAX updates (for quick view, etc.)
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && (
            node.matches('[data-product-thumbnails]') ||
            node.querySelector('[data-product-thumbnails]')
          )) {
            setTimeout(initThumbnailHover, 100);
          }
        });
      }
    });
  });

  // Observe the document for dynamic content changes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();
